import React from 'react';
import { StyleSheet, View } from 'react-native';

import { useStyles } from '~/hooks';
import { scaleSize } from '~/constants/scale';
import { Theme } from '~/theme';

type Props = {
    // Total number of steps.
    steps: number;
    // 0-based index of the current step.
    current: number;
};

// Wizard progress indicator: one segment per step (done/current filled). The step title lives
// in the screen header. Purely presentational — jumping between steps is the caller's concern.
export default function ProgressStepper({ steps, current }: Props) {
    const styles = useStyles(stylesGenerator);
    return (
        <View style={styles.container}>
            <View style={styles.segmentsRow}>
                {Array.from({ length: steps }, (_, i) => (
                    <View key={i} style={[styles.segment, i <= current ? styles.segmentActive : null]} />
                ))}
            </View>
        </View>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        container: {
            paddingVertical: scaleSize(8),
        },
        segmentsRow: {
            flexDirection: 'row',
        },
        segment: {
            flex: 1,
            height: scaleSize(3),
            borderRadius: scaleSize(2),
            backgroundColor: theme.equityValue,
            marginRight: scaleSize(4),
        },
        segmentActive: {
            backgroundColor: theme.button,
        },
    });
